<fp-matched-popup [showPopup]="isMentorContacted"></fp-matched-popup>

<fp-match-modal
  *ngIf="matchedRelation"
  [visible]="showMatchModal"
  [matchedRelation]="matchedRelation"
  [userRole]="currentUser?.role"
  [currentIndex]="matchModalIndex"
  [total]="matchModalItems.length"
  (ctaClicked)="onModalCtaClicked()"
  (nextClicked)="onModalNextClicked()"
  (closed)="onModalClosed()"
></fp-match-modal>
<div class="banner relative text-black" *ngFor="let bannerType of bannerTypes">
  <fp-head-banner [bannerType]="bannerType"></fp-head-banner>
  <p-button
    icon="pi pi-times"
    styleClass="p-button-rounded p-button-text absolute top-0 right-0"
    (onClick)="closeBanner(bannerType)"
  ></p-button>
</div>
<div class="header" [class.vis-banner]="isAnyBannerVisible()">
  <fp-header [user]="user$ | async" [notClickableHeader]="isWorkshopOnlyAttendee"></fp-header>
  <button
    *ngIf="!visibleSidebar"
    id="panel-button"
    (click)="visibleSidebar = true"
    pButton
    pRipple
    type="button"
    icon="pi pi-bars"
    class="p-button-rounded p-button-text"
  ></button>
</div>
<p-drawer [(visible)]="visibleSidebar" [baseZIndex]="100" position="right" [style]="{ width: '18rem' }">
  <fp-mobile-menu (hideSidebar)="hideSidebar()" [user]="user$ | async" [items]="items"></fp-mobile-menu>
</p-drawer>
<div class="main-container flex justify-content-center">
  <div class="inner-container">
    <div class="flex relative">
      <div *ngIf="(user$ | async)?.role !== 'LD'" id="left-menu" [class.vis-banner]="isAnyBannerVisible()">
        <fp-menu [items]="items" [user_role]="(user$ | async)?.role"></fp-menu>
      </div>
      <div #scrollContainer class="right-container" [class.vis-banner]="isAnyBannerVisible()" (scroll)="onContentScroll($event)">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
@if (showScrollTop) {
  <button type="button" class="scroll-top-button" (click)="scrollToTop()" aria-label="Scroll to top">
    <i class="pi pi-chevron-up"></i>
  </button>
}
